"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Box = _interopRequireDefault(require("../../Box"));
var _Divider = _interopRequireDefault(require("../../Divider"));
var _utils = require("../utils");
var _index = require("../views/index");
var _createRangeCalendarStateReducer = require("./createRangeCalendarStateReducer");
var _rangeUtils = require("./rangeUtils");
var _useHighlight2 = _interopRequireDefault(require("./useHighlight"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var RangeSelection = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _value$, _value$2;
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    onChange = _ref.onChange,
    showDaysOutsideCurrentMonth = _ref.showDaysOutsideCurrentMonth,
    renderDay = _ref.renderDay,
    minDateProp = _ref.minDate,
    maxDateProp = _ref.maxDate,
    minRangeDate = _ref.minRangeDate,
    maxRangeDate = _ref.maxRangeDate,
    disablePast = _ref.disablePast,
    disableFuture = _ref.disableFuture,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? "date" : _ref$view,
    shouldDisableDate = _ref.shouldDisableDate,
    _ref$openPeriod = _ref.openPeriod,
    openPeriod = _ref$openPeriod === void 0 ? false : _ref$openPeriod;
  var viewHelpers = (0, _utils.useViewHelpers)(view);
  var minDate = viewHelpers.startOfItem(minDateProp);
  var maxDate = viewHelpers.startOfItem(maxDateProp);
  var emptyStartDate = (0, _react.useMemo)(function () {
    return (0, _utils.getEmpty)(minDate, maxDate);
  }, [minDate, maxDate]);
  var _useReducer = (0, _react.useReducer)((0, _createRangeCalendarStateReducer.createRangeCalendarStateReducer)(viewHelpers), (0, _react.useMemo)(function () {
      return {
        range: (0, _rangeUtils.getRange)(value, emptyStartDate, viewHelpers, openPeriod),
        focusedDate: viewHelpers.startOfItem(value[0] || emptyStartDate)
      };
    }, [value === null || value === void 0 || (_value$ = value[0]) === null || _value$ === void 0 ? void 0 : _value$.getTime(), value === null || value === void 0 || (_value$2 = value[1]) === null || _value$2 === void 0 ? void 0 : _value$2.getTime(), emptyStartDate.getTime(), viewHelpers, openPeriod])),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    range = _useReducer2$.range,
    focusedDate = _useReducer2$.focusedDate,
    lastFocusedOrHoveredDate = _useReducer2$.lastFocusedOrHoveredDate,
    dispatch = _useReducer2[1];
  var reset = function reset() {
    var newValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    dispatch({
      type: _createRangeCalendarStateReducer.RESET,
      payload: {
        range: (0, _rangeUtils.getRange)(newValue, emptyStartDate, viewHelpers, openPeriod),
        focusedDate: viewHelpers.startOfItem(newValue[0] || emptyStartDate)
      }
    });
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      reset: reset
    };
  });
  var rangeMinMaxDates = (0, _react.useMemo)(function () {
    return (0, _rangeUtils.getRangeMinMaxDate)(range, {
      minDate: minDate,
      maxDate: maxDate
    }, viewHelpers);
  }, [range, minDate, maxDate]);
  var handleChangeRangeDateByIndex = function handleChangeRangeDateByIndex(index) {
    return function (date, isFinish) {
      dispatch({
        type: _createRangeCalendarStateReducer.CHANGE_RANGE_DATE_BY_INDEX,
        payload: {
          index: index,
          isFinish: isFinish,
          newDate: date
        }
      });
    };
  };
  var handleIsDateSelected = (0, _react.useCallback)(function (day) {
    return value.some(function (v) {
      return viewHelpers.isSameItem(day, v);
    });
  }, [value]);
  var handleDateSelect = function handleDateSelect(date) {
    if (openPeriod) {
      onChange([date, null], true);
    } else {
      var dates = value.length === 2 ? [date] : [].concat(_toConsumableArray(value), [date]);
      var newValue = (0, _rangeUtils.getRangeValue)(dates, viewHelpers);
      onChange(newValue, newValue.length === 2);
    }
  };
  var isDateEnable = (0, _utils.useIsDateEnable)({
    minDate: minRangeDate,
    maxDate: maxRangeDate,
    disablePast: disablePast,
    disableFuture: disableFuture
  });
  var handleIsDateDisabled = (0, _react.useCallback)(function (day) {
    return isDateEnable(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
  }, [shouldDisableDate, isDateEnable]);
  var handleChangeFocusedDateByIndex = function handleChangeFocusedDateByIndex(index) {
    return function (date) {
      dispatch({
        type: _createRangeCalendarStateReducer.CHANGE_FOCUSED_DATE,
        payload: {
          index: index,
          newFocusedDate: date
        }
      });
    };
  };
  var handleChangeHoveredDate = function handleChangeHoveredDate(date) {
    dispatch({
      type: _createRangeCalendarStateReducer.SET_HOVERED_DATE,
      payload: {
        newHoveredDate: date
      }
    });
  };
  var _useHighlight = (0, _useHighlight2["default"])({
      start: value[0],
      end: value[1] || (openPeriod ? emptyStartDate : lastFocusedOrHoveredDate)
    }, viewHelpers),
    isHighlight = _useHighlight.isHighlight,
    isFirstHighlight = _useHighlight.isFirstHighlight,
    isLastHighlight = _useHighlight.isLastHighlight;
  (0, _react.useLayoutEffect)(function () {
    if (value.length === 2) {
      var visible = value.every(function (v) {
        return !v || range.some(function (d) {
          return viewHelpers.isSameView(v, d);
        });
      });
      if (!visible) {
        reset(value);
      }
    }
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box["default"], {
    display: "flex",
    justifyContent: "space-between",
    children: range.map(function (current, index) {
      var _rangeMinMaxDates$ind = rangeMinMaxDates[index],
        minDate = _rangeMinMaxDates$ind.minDate,
        maxDate = _rangeMinMaxDates$ind.maxDate;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [index ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {
          orientation: "vertical",
          flexItem: true
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ViewSwitcher, {
          "data-cy-lebel": index === 0 ? "startDate" : index === range.length - 1 ? "endDate" : null,
          view: view,
          minDate: minDate,
          maxDate: maxDate,
          disablePast: disablePast,
          disableFuture: disableFuture,
          current: current,
          focusedDate: focusedDate,
          onDateSelect: handleDateSelect,
          onDateFocus: handleChangeFocusedDateByIndex(index),
          onDateHover: handleChangeHoveredDate,
          onCurrentChange: handleChangeRangeDateByIndex(index),
          isDateHighlighted: isHighlight,
          isDateHighlightStart: isFirstHighlight,
          isDateHighlightEnd: isLastHighlight,
          isDateSelected: handleIsDateSelected,
          isDateDisabled: handleIsDateDisabled,
          showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
          renderDay: renderDay
        })]
      }, index);
    })
  });
});
var _default = exports["default"] = RangeSelection;